import { render, staticRenderFns } from "./InviteNewBusinesses.vue?vue&type=template&id=62139621&scoped=true"
import script from "./InviteNewBusinesses.vue?vue&type=script&lang=js"
export * from "./InviteNewBusinesses.vue?vue&type=script&lang=js"
import style0 from "./InviteNewBusinesses.vue?vue&type=style&index=0&id=62139621&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62139621",
  null
  
)

export default component.exports